import type {ModuleEnum} from 'src/api/ProactApiClient';
import {TaskCustomOperations} from './customOperations';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for task-like module permissions (Actions, AssignedForms, ToolboxTalks, etc.).
 * Includes standard operations plus task-specific custom operations for state transitions.
 *
 * @param module - The specific task-like module to check permissions for
 */
export function useTaskPermissions(module: ModuleEnum) {
  return useModulePermissions(module, TaskCustomOperations);
}
